import { AfterViewInit, Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MediaService } from "../../../services/media.service";
import { MediaModel } from "../../../models/MediaModel";
import { CropperSettings } from 'ngx-img-cropper';
import { AreasService } from "../../../services/areas.service";
import { Globals } from "../../../services/globals";
import { InspirationRoomModel } from "../../../models/InspirationRoomModel";
import { InspirationRoomService } from "../../services/inspiration-rooms/inspiration-room.service";
import { InspirationRoomOptionModel } from "../../../models/InspirationRoomOptionModel";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Observable } from "rxjs";

import { UntypedFormControl } from "@angular/forms";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { map, startWith } from "rxjs/operators";
import { ImageCroppedEvent, ImageCropperComponent } from "ngx-image-cropper";
import { Area } from "../../../engine/models/models";
import { CommunityLotService } from "../../../services/communitylot.service";
import { Communities } from "../../../models/communities";
import { Lots } from "../../../models/Lots";
import { InspirationGroup } from "../../../models/InspirationGroupModel";
import { InspirationGroupService } from "../../../services/inspiration-group.service";
import { AreaType } from "../../../enum";



@Component({
  selector: 'resizer-component',
  templateUrl: 'resizer.component.html',
  styleUrls: ['resizer.component.css'],
})

export class ResizerComponent implements OnInit, AfterViewInit {
  //@ViewChild('imageCropper') imageCropper: ImageCropperComponent;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperPoints: any = { x1: 0, y1: 0, x2: 0, y2: 0 };
  isValidInspirationRoomArea = true;
  isValidInspirationRoomName = true;
  selected = true;
  croppedHeight = 2800;
  croppedwidth = 5600;
  inspirationRoomArea: string = "0";
  inspirationRoomGroup: string = "0";
  inspirationRoomSubGroup: string = "0";
  inspirationRoomName: string;
  defaultLanguageCode: string = 'en';
  media: MediaModel;
  areas: Area[];
  communities: Communities[];
  filteredCommunities: Observable<Communities[]>;
  filteredDsArea: Observable<Area[]>;
  lots: Lots[];
  filteredLots: any;
  isCommunity: boolean = true;
  isLot: boolean = true;
  isDsArea: boolean = true;
  cropperSettings: CropperSettings;
  data: any;
  insperationRoomId: any;
  private isEdit: number;
  inspirationRoom: InspirationRoomModel = new InspirationRoomModel();
  inspirationRoommodel: InspirationRoomOptionModel = new InspirationRoomOptionModel();
  myControl = new UntypedFormControl();
  dsAreaControl = new UntypedFormControl();
  inspirationGroup: InspirationGroup[];
  isInspiration: boolean = true;
  filterSubGroup: any;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  @ViewChild(MatAutocompleteTrigger) dsAreaAutoComplete: MatAutocompleteTrigger;
  constructor(private router: Router,
    private inspirationRoomService: InspirationRoomService,
    private communityLotService: CommunityLotService,
    private route: ActivatedRoute,
    private mediaService: MediaService,
    private areasService: AreasService,
    private globals: Globals,
    private renderer: Renderer2,
    private ngxUiLoaderService: NgxUiLoaderService,
    private inspirationGroupService: InspirationGroupService) {
    globals.hideHeader = false;

    const width = window.innerWidth / 2;
    this.cropperSettings = new CropperSettings();
    this.data = {};
  }

  imageCropped(event: ImageCroppedEvent) {
    this.inspirationRoom.origin = event.imagePosition.x1 + "," + event.imagePosition.x2 + "," + event.imagePosition.y1 + "," + event.imagePosition.y2;
    this.croppedHeight = event.imagePosition.y2 - event.imagePosition.y1;
    this.croppedwidth = event.imagePosition.x2 - event.imagePosition.x1;
    this.inspirationRoom.cropperPosition = event.cropperPosition.x1 + "," + event.cropperPosition.x2 + "," + event.cropperPosition.y1 + "," + event.cropperPosition.y2;
  }

  cropperReady() {
    this.setCropperPoints();
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
  setCropperPoints() {
    if (this.inspirationRoom.cropperPosition !== null && this.inspirationRoom.cropperPosition !== undefined) {
      const cropperPosition = this.inspirationRoom.cropperPosition.split(',');
      this.cropperPoints = {
        x1: Number(cropperPosition[0]),
        x2: Number(cropperPosition[1]),
        y1: Number(cropperPosition[2]),
        y2: Number(cropperPosition[3]),
      };
    }
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start();
    this.isEdit = this.route.params["value"].type;
    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.initalize(+params["id"]);
        this.inspirationRoom.backgroundId = +params["id"];
      }
      if (params["rid"]) {
        this.inspirationRoom.id = +params["rid"];
        this.insperationRoomId = this.inspirationRoom.id;
      }
    });
    // this.getCommunitiesAndLots();
    this.getAreas();
    this.getInspirationGroups();
    if (this.insperationRoomId != 0 && this.isEdit == 1) {
      this.getRoom();
    }
    else {
      this.inspirationRoom.lot = "0";
      this.getCommunitiesAndLots();
      this.globals.insperationalRoomId = 0;
      this.inspirationRoom.name = "Untitled " + this.inspirationRoom.backgroundId;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.filteredCommunities = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))

        );

    }, 1000);
  }

  initalize(mediaId: number) {
    const image = new Image();
    image.crossOrigin = "Anonymous";
    this.mediaService.getMediaById(mediaId)
      .subscribe(response => {
        this.media = response.media;
        image.src = response.media.url;
        this.croppedImage = response.media.url;
        image.onload = () => {
          // this.cropper.setImage(image);
          this.ngxUiLoaderService.stop();
        };
      });
  }

  private _filter(value: string): Communities[] {
    // Check for null, undefined, or empty strings
    if (!value) return;
    const filterValue = value.toLowerCase();

    const filtered = this.communities.filter(community => (
      (community.communityName && community.communityName.toLowerCase().includes(filterValue))
      || (community.communityCode && community.communityCode?.toLowerCase().includes(filterValue))
    ));
    if (value.length < 2) {
      this.inspirationRoom.lot = "0";
    }
    if (filtered.length < 10) return filtered;

    return filtered.slice(0, 10);
  }

  navigateToGallery() {
    this.router.navigate(['/upload']);
  }

  getCommunitiesAndLots() {
    this.communityLotService.getCommunitiesAndLots().subscribe(results => {
      this.communities = results.communities;
      this.communities = this.communities.filter((v, i, a) => a.findIndex(t => (t.communityId === v.communityId)) === i);
      this.lots = results.lots;
      if (this.inspirationRoom.communityId > 0) {
        this.myControl.setValue(this.communities.find(x => x.communityId === this.inspirationRoom.communityId).communityName);
        this.onCommunityChange(this.inspirationRoom.communityId);
      }
    });
  }

  validate() {
    //this.isInspiration = true;
    this.isCommunity = true;
    this.isLot = true;
    this.isDsArea = true;
    this.isValidInspirationRoomName = true;
    if (this.myControl.value === "" || this.inspirationRoom.communityId < 1 || this.inspirationRoom.communityId === undefined) {
      this.isCommunity = false;
    }
    if ((this.inspirationRoom.lot === undefined || this.inspirationRoom.lot === "" || this.inspirationRoom.lot === "0") && this.inspirationRoom.communityId > 0) {
      this.isLot = false;
    }
    if (this.inspirationRoom.name === undefined || this.inspirationRoom.name === "") {
      this.isValidInspirationRoomName = false;
    }

  }
  validateLot() {
    this.isLot = true;
    if ((this.inspirationRoom.lot === undefined || this.inspirationRoom.lot === "" || this.inspirationRoom.lot === "0") && this.inspirationRoom.communityId > 0) {
      this.isLot = false;
    }
  }

  save(type: string) {
    if (this.myControl.value == "") {
      this.inspirationRoom.communityId = 0;
    }
    //this.imageCropper.crop();
    this.validate();
    this.ngxUiLoaderService.start();
    this.inspirationRoom.createdbyId = localStorage.getItem("userId");
    this.isValidInspirationRoomName = this.inspirationRoom.name?.length > 0;
    this.inspirationRoomName = this.inspirationRoom.name;
    this.inspirationRoomArea = this.inspirationRoom.areaId.toString();
    this.inspirationRoomGroup = this.inspirationRoom.inspirationGroupId.toString();

    if (!this.inspirationRoom.name || this.inspirationRoom.name === "") {
      this.isCommunity = true;
      this.ngxUiLoaderService.stop();
      return;
    }

    if (this.inspirationRoom.communityId) {
      if (!this.isValidInspirationRoomArea || !this.isValidInspirationRoomName || this.inspirationRoom.communityId < 1
        || this.inspirationRoom.lot === "" || this.inspirationRoom.lot === "0" || this.inspirationRoom.lot === undefined) {
        this.ngxUiLoaderService.stop();
        return;
      }
    }
    else {
      this.isCommunity = true;
      this.isLot = true;
    }

    this.saveRoom();
    if (this.inspirationRoom.id < 1 && this.inspirationRoom.communityId) {
      const communityId = this.communities.find(x => x.communityId === this.inspirationRoom.communityId).communityId;
      const childAreas = this.areas.find(x => x.id === this.inspirationRoom.areaId).subAreas;
      let childAreasIds = [];
      if (childAreas.length > 0) {
        childAreasIds = childAreas.map(({ id }) => id);
      }
      this.inspirationRoomService.getOptions(communityId, this.inspirationRoom.lot).subscribe(results => {
        if (childAreasIds && results != null) {
          results = results.filter(function (option) {
            return childAreasIds.filter(function (areaId) {
              return areaId === option.areaId;
            }).length;
          });
        }
        else {
          results = null;
        }
        this.inspirationRoom.requiredOptions = results;
        this.inspirationRoomService.updateRoom(this.inspirationRoom).subscribe(result => {
          this.ngxUiLoaderService.stop();
          if (type === 'so') {
            this.router.navigate(['/edit/' + result.id]);
          }
          else {
            this.router.navigate(['/gallery']);
          }
        });
      });
    }
    else {
      this.inspirationRoomService.updateRoom(this.inspirationRoom).subscribe(result => {
        this.ngxUiLoaderService.stop();
        if (type === 'so') {
          this.router.navigate(['/edit/' + result.id]);
        }
        else {
          this.router.navigate(['/gallery']);
        }
      });
    }
  }
  saveRoom() {
    if (this.globals.insperationalRoomId != 0) {
      this.inspirationRoom.options = [];
      this.inspirationRoom.name = this.inspirationRoom.name;
      this.inspirationRoom.areaId = this.inspirationRoom.areaId;
      this.inspirationRoom.inspirationGroupId = this.inspirationRoom.inspirationGroupId;
      this.inspirationRoom.inspirationSubGroupId = this.inspirationRoom.inspirationSubGroupId;
      this.inspirationRoom.isActive = true;
      this.inspirationRoom.createdbyId = localStorage.getItem("userId");
    }
    else {
      this.inspirationRoom.options = [];
      this.inspirationRoommodel.absoluteX = this.croppedHeight;
      this.inspirationRoommodel.absoluteY = this.croppedwidth;
      this.inspirationRoom.options.push(this.inspirationRoommodel);
      this.inspirationRoom.name = this.inspirationRoomName;
      this.inspirationRoom.areaId = parseInt(this.inspirationRoomArea);
      this.inspirationRoom.inspirationGroupId = parseInt(this.inspirationRoomGroup);
      this.inspirationRoom.inspirationSubGroupId = parseInt(this.inspirationRoomSubGroup);
      this.inspirationRoom.isActive = true;
      this.inspirationRoom.id = 0;
      this.inspirationRoom.backgroundUrl = "";
      this.inspirationRoom.thumbnailUrl = "";
      this.inspirationRoom.createdbyId = localStorage.getItem("userId");
    }
  }
  getRoom() {
    this.inspirationRoomService.getRoomByRoomId(this.insperationRoomId, this.defaultLanguageCode).subscribe(room => {
      if (room) {
        this.inspirationRoom = room;
        this.inspirationRoom.areaId = this.inspirationRoom.areaId;
        this.inspirationRoom.inspirationGroupId = this.inspirationRoom.inspirationGroupId;
        this.inspirationRoom.inspirationSubGroupId = this.inspirationRoom.inspirationSubGroupId;
        this.setCropperPoints();
        this.filterSubGroup = this.inspirationGroup.find(x => x.id == this.inspirationRoom.inspirationGroupId).inspirationSubGroups;
        this.getCommunitiesAndLots();
      }
    });
  }

  getAreas() {
    this.areasService.getAreas().subscribe(areas => {
      this.areas = areas.filter(x => x.areaType == AreaType.Area);
      this.inspirationRoom.areaId = this.areas[0].id;
    });
  }
  communityChange(communityId: number) {
    this.inspirationRoom.lot = "";
    this.onCommunityChange(communityId);
  }

  onCommunityChange(communityId: number) {
    this.isCommunity = true;
    this.inspirationRoom.communityId = communityId;
    if (this.lots !== undefined) {
      this.filteredLots = this.lots.filter(x => x.communityId === this.inspirationRoom.communityId);
      this.filteredLots = this.filteredLots.filter(
        (thing, i, arr) => arr.findIndex(t => t.lotId === thing.lotId) === i
      );
    }
  }

  getInspirationGroups() {
    this.inspirationGroupService.getInspirationGroups().subscribe(inspirationGroup => {
      this.inspirationGroup = inspirationGroup;
      this.inspirationRoom.inspirationGroupId = inspirationGroup[0].id;
    });
  }

  //ValidateInspiration() {
  //  this.inspirationRoom.inspirationSubGroupId = 0;
  //  this.isInspiration = true;
  //  this.isCommunity = true;
  //  this.isLot = true;
  //  if (!this.inspirationRoom.inspirationGroupId) {
  //    this.isInspiration = false;
  //  }

  //  this.filterSubGroup = this.inspirationGroup.find(x => x.id == this.inspirationRoom.inspirationGroupId).inspirationSubGroups;



  //}
}
